import "core-js/stable";
import "regenerator-runtime/runtime";

// disable until full turboing
import { Turbo } from "@hotwired/turbo-rails";
Turbo.session.drive = false;
global.jQuery = require('jquery');
global.$ = require('jquery');

require("@rails/ujs").start();
require("@rails/activestorage").start();
require("channels");
require("controllers");

require('moment');
require('moment-timezone');
import 'crypto-js';
require("src/tokens");

import LocalTime from 'local-time';
LocalTime.start();

const images = require.context('../images', true);
const imagePath = (name) => images(name, true);

import 'stylesheets/font-awesome'
import 'stylesheets/application';

document.addEventListener("turbo:before-cache", function() {
  $('[data-no-cache]').remove();
  $('[data-toggle="popover"]').popover();
});
